module.exports = __webpack_public_path__ + "img/main_wfh.51a25b28.jpg";